













import { Component, Vue, Prop } from 'vue-property-decorator';
import { IUser, ICustomer } from '@/lib/interfaces';

@Component
export default class CustomerRow extends Vue {
  @Prop() private customer!: ICustomer;
}
